import { useState } from 'react';

import useInertiaEvent from './useInertiaEvent';

const normalizeUrl = (url: URL): string => {
    const urlWithoutSearch = url.toString().replace(url.search, '');

    return urlWithoutSearch.endsWith('/')
        ? urlWithoutSearch.slice(0, -1)
        : urlWithoutSearch;
};

const useCurrentUrl = () => {
    const [url, setUrl] = useState(() =>
        normalizeUrl(new URL(window.location.href))
    );

    useInertiaEvent('start', (event) => {
        /** Only update the URL if it's a GET request. */
        if (event.detail.visit.method !== 'get') {
            return;
        }

        setUrl(normalizeUrl(event.detail.visit.url));
    });

    return url;
};

export default useCurrentUrl;
